import { render, staticRenderFns } from "./ActivateProfile.vue?vue&type=template&id=77f3478e&scoped=true"
import script from "./ActivateProfile.vue?vue&type=script&lang=js"
export * from "./ActivateProfile.vue?vue&type=script&lang=js"
import style0 from "./ActivateProfile.vue?vue&type=style&index=0&id=77f3478e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f3478e",
  null
  
)

export default component.exports